import { apiRequest, graphqlRequest } from './index'

export const getRecords = (data) => {
  return graphqlRequest(`
  {
    getRecords {
      ${ data }
    }
  }
  `)
}


export const uploadAttachment = (_id, category, file, event) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('data', JSON.stringify({
    attachmentInfo: {
      _id,
      category,
    },
    event
  }))

  return apiRequest('POST', '/api/beneficiary/rest/v1/uploadAttachment', formData, { 'content-type': 'multipart/form-data' })
}

export const deleteAttachment = (_id, fileKeys) => {

  return graphqlRequest(`
    mutation {
    removeAttachment(
        _id: "${ _id }"
        fileKeys: ["${ fileKeys.join('","') }"]
      ) {
        attachments {
          category
          key
          name
          size
          audited
          auditedBy
          auditOk
        }
      }
    }`)
}

export const getRecord = (_id, data) => {
  return graphqlRequest(`{
    getRecord(_id: "${ _id }"){
      ${ data }
    }
  }`)
}
export const createRecord = (simulation) => {
  return graphqlRequest(`
  mutation {
    createRecord(simulation: {
      ${ simulation.singleParent ? 'singleParent: true' : '' }
      ${ simulation.childSupport ? `childSupportAnnualAmount:${ simulation.childSupport }` : '' }
      ${ (simulation.partnerIncome || simulation.partnerIncome === 0) ? `partnerAnnualNetIncome:${ simulation.partnerIncome }` : '' }
    }) {
      _id
      status
    }
  }`)

}

export const deleteRecord = (_id) => {
  return graphqlRequest(`
  mutation {
    deleteRecord(
      _id: "${ _id }"
    )
  }`)
}

export const updateRecordQuery = (id, status, query, data) => {
  return graphqlRequest(`
  mutation {
    updateRecord(record: {
      _id: "${ id }"
      status: "${ status }"
      ${ query ? query : '' }
    }) {
      ${ data }
    }
  }`)
}

export const submitRecord = (_id, consent, data) => {
  return graphqlRequest(`
  mutation {
    submitRecord( _id: "${ _id }" consent: "${ consent }" ){
     ${ data }
    }
  }`)
}
